import React, { Component } from 'react';
import { Table, Input, Select, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import PreviewModal from '../PreviewModal';
import API_URL from '../../../common/url';

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {}
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    render() {
        const { searchParams: { employeeCode, userCompellation, regionName, dimissionStatus } } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">工作城市</label>
                    <Input
                        placeholder="请输入"
                        value={regionName}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'regionName')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">状态</label>
                    <Select
                        placeholder="请选择"
                        value={dimissionStatus}
                        allowClear={true}
                        style={{width: 80}}
                        onChange={value => this.handleSelectChange(value, 'dimissionStatus')}
                    >
                        <Option value="WORKING">在职</Option>
                        <Option value="LEFT">离职</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class OverView extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.querySupervisorList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = searchParams => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, sortParams, searchParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.user.exportSupervisorList);
    }

    getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: true,
            width: 100,
            render: (text, record) => {
                const { userId } = record;
                return <a onClick={() => this.showPreviewModal(userId)}>{text}</a>
            }
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 80,
        }, {
            title: '主管领导',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            width: 100,
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
            width: 150,
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 200,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            render: text => text ? (text === 'WORKING' ? '在职' : "离职") : '',
            width: 80,
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => ({
            index: index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    showPreviewModal = userId => {
        this.previewModalRef.show(userId);
    }

    render() {
        const { loading, pagination } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Table
                    bordered
                    loading={loading}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={row => row.index}
                    onChange={this.handleTableChange}
                />
                <PreviewModal ref={el => this.previewModalRef = el} />
            </div>
        );
    }
}

export default OverView;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/OverView.js